import { routes } from "@/global/routes";
import {
  faqs,
  howItWorks,
  TexasRangersCheckoutTerms,
  TexasRangersAdditionalDetailsDisclaimerTC,
  AnalyticsHeader,
} from "./helpers";
import { vendorUUIDs } from "../../constants";
import { DefaultRegistrationTerms } from "../../default_terms_and_conditions";
import SeatMap3dPreview from "public/images/diamondbacks/seat_map_preview.png";
import BackgroundImage from "public/images/texasrangers/rangersstadium.jpg";
import type { TeamConfig } from "../types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/T_Primary.png";
const BannerImage =
  "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/texas-rangers-banner.jpg";

const HOFSuiteImages = [
  "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Hall%20of%20Fame%20Suite.jpg",
  "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/2020_Suite_kgTXR_0036.jpg",
  "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/HOFSuites_7.jpg",
  "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/HOFSuites_16.jpg",
];

const config: TeamConfig = {
  teamSchema: "texasrangers_suites",
  browserTitle: "Texas Rangers",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  mlbTeamId: 140,
  teamName: "Texas Rangers",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-00084-rangers-sec",
    mapId: "main",

    suiteImages: {
      HOFS201A: HOFSuiteImages,
      HOFS201B: HOFSuiteImages,
      HOFS202A: HOFSuiteImages,
      HOFS202B: HOFSuiteImages,
      HOFS203A: HOFSuiteImages,
      HOFS203B: HOFSuiteImages,
      HOFS204A: HOFSuiteImages,
      HOFS204B: HOFSuiteImages,
      HOFS205A: HOFSuiteImages,
      HOFS205B: HOFSuiteImages,
      HOFS206A: HOFSuiteImages,
      HOFS206B: HOFSuiteImages,
      PS202: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/202/2020_Suite_GAVN3697%20Large.jpeg",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/202/2020_Suite_GAVN3709%20Large.jpeg",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/202/2020_Suite_GAVN3760%20Large.jpeg",
      ],
      PS201: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/202/2020_Suite_GAVN3697%20Large.jpeg",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/202/2020_Suite_GAVN3709%20Large.jpeg",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/202/2020_Suite_GAVN3760%20Large.jpeg",
      ],
      PS104: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/103/2020_Suite_GAVN4163%20Large.jpeg",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/103/2020_Suite_GAVN4252%20Large.jpeg",
      ],
      PS103: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/103/2020_Suite_GAVN4163%20Large.jpeg",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/Party%20Suites%20Images%20Attend/103/2020_Suite_GAVN4252%20Large.jpeg",
      ],

      CS201: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3049.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3047.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3028.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3016.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3004.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_2993.JPG",
      ],

      CS202: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3049.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3047.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3028.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3016.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3004.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_2993.JPG",
      ],

      CS242: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3049.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3047.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3028.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3016.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3004.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_2993.JPG",
      ],

      CS243: [
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3049.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3047.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3028.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3016.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_3004.JPG",
        "https://ss-leagues.s3.amazonaws.com/MLB/TX Rangers Suites/Classic Suites/20241015_TXR_KW1_2993.JPG",
      ],
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SUITE-LEVEL-V2",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    hideViewTicketsInThankYouPage: true,

    isCheckoutAdditionalDetailsEnabled: true,
    isPerksEnabled: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    googleTagManagerId: "GTM-MXM33L",
    AnalyticsHeader: AnalyticsHeader,
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,

  isSaveCardAllowed: false,

  // urls
  accountManagerUrl: "https://www.mlb.com/rangers/tickets",

  // vendor
  platform: vendorUUIDs.tickesdotcom,

  // okta config
  oktaIssuer: "https://dev-55402235.okta.com/oauth2/default",
  oktaClientId: "0oacy095w9UU4wAij5d7",
  shouldUseInternalLogin: false,

  isBrainTreePaymentEnabled: false,

  // images
  images: {
    findGamesBannerImage: BannerImage,
    authBackgroundImage: BackgroundImage.src,
    checkoutStatusPageImage: BackgroundImage.src,
    giftCardStandalonePageImage: BannerImage,
    logoImage: LogoImage + "?width=128&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    hidePackageBalanceOnCheckout: true,
    hideServiceFee: true,

    inventoryCardSettings: {
      isPBLineItemsVisible: true,
      seatCountLabel: "Tickets Included",
      inventorySuitePackageInfo: [
        { suiteId: "Hall of Fame Suite 201A", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 201B", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 202A", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 202B", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 203A", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 203B", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 204A", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 204B", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 205A", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 205B", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 206A", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 206B", FBPackageValue: "$600 Credit" },
        { suiteId: "Hall of Fame Suite 207A", FBPackageValue: "$600 Credit" },
        { suiteId: "Classic Suite 201", FBPackageValue: "$600 Credit" },
        { suiteId: "Classic Suite 202", FBPackageValue: "$600 Credit" },
        { suiteId: "Classic Suite 242", FBPackageValue: "$600 Credit" },
        { suiteId: "Classic Suite 243", FBPackageValue: "$600 Credit" },
        { suiteId: "Party Suite 201", FBPackageValue: "Package" },
        { suiteId: "Party Suite 202", FBPackageValue: "Package" },
        { suiteId: "Party Suite 103", FBPackageValue: "Package" },
        { suiteId: "Party Suite 104", FBPackageValue: "Package" },
      ],

      pbLineItemsValue: 5,
      FBLabel: "F&B Included:",
      isParkingSeatCountVisible: true,
    },
    inventoryContainer: {
      getGridCellHeight: (arg) => (arg?.mdDown ? 260 : 180),
    },

    perks: {
      hideAddAllButton: true,
      isOpenByDefault: true,
    },

    eventCardSettings: {
      soldOutTagLabel:
        "Limited inventory - contact premiumsales@texasrangers.com for options",
    },
  },

  colors: {
    primary: "#003278",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: null,
    checkoutTermsAndCondition: <TexasRangersCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    additionalDetailsDisclaimerTC: (
      <TexasRangersAdditionalDetailsDisclaimerTC />
    ),
    purchaseSeats: {
      progressBarSuccessText:
        "You're good to go! Add more games or select Continue to view seating options.",
      progressBarAditionalText: " to continue!",
      noSessionsAvailable:
        "Check back soon for 2026 online suite availability.",
      noSessionsAvailableDescription: " ",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutServiceNote:
      "Your reservation is not yet complete until notification from the Texas Rangers confirming your reservation has been accepted in accordance with our agreement.",

    giftCard: {
      title: "Give The Gift Of Broadway",
      createGiftCard: {
        description:
          "Share the magic of Broadway with a friend or loved one. Upon purchase of a gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift card is not refundable.",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
        },
        logout: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore.",
        },
        success: {
          description:
            "has been added to your Hippodrome Broadway Series in Baltimore Account Manager account!",
        },
      },
    },

    signInAuthText:
      "Connect your mlb.com account to continue with seamless access.",
  },
};

export default config;
